import request, { ResponseData } from '@/utils/request'
import { CustomEvaluateSaveReq, CustomEvaluateListReq } from './model'

// 保存自定义评价
export async function saveAppraise(params): Promise<ResponseData<CustomEvaluateSaveReq>> {
  return request('/api/v1/training/custom/evaluate/save', {
    method: 'post',
    data: params,
  })
}

// 自定义评价列表
export async function fetchAppraiseList(params): Promise<ResponseData<CustomEvaluateListReq>> {
  return request('/api/v1/training/custom/evaluate/list', {
    method: 'post',
    data: params,
  })
}

// 自定义评价详情
export async function fetchAppraiseDetail(params): Promise<ResponseData<null>> {
  return request('/api/v1/training/custom/evaluate/detail', {
    method: 'post',
    data: params,
  })
}

// 自定义评价批量分组
export async function appraisesMove(params): Promise<ResponseData<null>> {
  return request('/api/v1/training/custom/evaluate/move', {
    method: 'post',
    data: params,
  })
}

// 自定义评价批量删除
export async function appraisesDel(params): Promise<ResponseData<null>> {
  return request('/api/v1/training/custom/evaluate/del', {
    method: 'post',
    data: params,
  })
}

// 自定义评价分组列表
export async function fetchAppraiseGroupsList(params): Promise<ResponseData<null>> {
  return request('/api/v1/training/custom/evaluate/group/list', {
    method: 'post',
    data: params,
  })
}

// 自定义评价分组保存
export async function appraiseGroupSave(params): Promise<ResponseData<null>> {
  return request('/api/v1/training/custom/evaluate/group/save', {
    method: 'post',
    data: params,
  })
}

// 自定义评价分组删除
export async function appraiseGroupsDel(params): Promise<ResponseData<null>> {
  return request('/api/v1/training/custom/evaluate/group/del', {
    method: 'post',
    data: params,
  })
}

// 自定义评价分组清空
export async function emptyAppraiseGroups(params): Promise<ResponseData<null>> {
  return request('/api/v1/training/custom/evaluate/group/clear', {
    method: 'post',
    data: params,
  })
}
